import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

interface Props {
    $preventOverflow?: boolean;
}

export const TextRevealWrapper = styled(motion.div)<Props>`
    display: ${({ $preventOverflow }) => ($preventOverflow ? 'flex' : 'block')};

    ${({ $preventOverflow }) =>
        $preventOverflow &&
        css`
            overflow: hidden;
        `}
`;

export const Word = styled.div`
    display: inline-flex;
`;

export const Character = styled(motion.span)`
    white-space: break-spaces;
    display: inline-block;
`;
